module.exports = __webpack_public_path__ + "img/symbol_9.22bf7517.png";